import Divider from './dividerBlock';

export default Divider;
